<script lang="ts">
  import { onMount } from "svelte";
  import { account } from "$lib/stores/account";
  import { cart } from "$lib/stores/cart";
  import client from "$lib/gql/apolloClient";
  import { GetCustomerInfoForDataLayerDoc } from "$lib/gql/gen/codegen";
  import type { GetCustomerInfoForDataLayerQuery } from "$lib/gql/gen/codegen";
  import { getEcommerceEventItemsFromBasketItems } from "$lib/utils/gtmEvent";
  import { sessionStore } from "$lib/stores/session";
  import { get } from "svelte/store";

  export let data: { [key: string]: any } = {};
  export let eec = false;

  const getSession = sessionStore();
  const session = get(getSession);

  const cost = $cart?.cost;
  const quantity = $cart?.totalQuantity;

  onMount(async () => {
    let regDate: string = undefined;
    let firstOrderDate: string = undefined;
    let lastOrderDate: string = undefined;

    if ($account) {
      const res = await client.query<GetCustomerInfoForDataLayerQuery>({
        query: GetCustomerInfoForDataLayerDoc,
        variables: {
          accessToken: $account.accessToken,
        },
      });
      if (res.data && res.data.customer) {
        const customerData = res.data.customer;
        regDate = customerData.createdAt
          ? new Date(customerData.createdAt).toISOString().split("T")[0]
          : undefined;
        firstOrderDate =
          customerData.firstOrder.edges.length > 0
            ? new Date(customerData.firstOrder.edges[0].node.processedAt)
                .toISOString()
                .split("T")[0]
            : undefined;
        lastOrderDate =
          customerData.lastOrder.edges.length > 0
            ? new Date(customerData.lastOrder.edges[0].node.processedAt)
                .toISOString()
                .split("T")[0]
            : undefined;
      }
    }

    if (!eec && $cart) {
      // Ecommerce GA4
      data = {
        ...data,
        visitorIP: session?.clientIP,
        country: session?.clientRegion,
        user: {
          userId: $account ? $account.userId : "Unregistered",
          status: $account ? "Logged In" : "Logged Out",
          email: $account ? $account.email : "",
          registrationDate: regDate,
          firstPurchaseDate: firstOrderDate,
          lastPurchaseDate: lastOrderDate,
        },
        ecommerce: {
          basket: {
            summary: {
              total: parseFloat(cost?.totalAmount?.amount),
              quantity: quantity,
            },
            items: getEcommerceEventItemsFromBasketItems($cart?.lines?.edges),
          },
          ...data.ecommerce,
        },
      };
    }
    const dataLayer = (window as any).dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push(data);
  });
</script>
